//test

//Global Js
import './bootstrap';

//Global Style
import './styles.js';

import * as Sentry from '@sentry/browser';
if (morettoDsn) {
  Sentry.init({
    dsn: morettoDsn,
    release: process.env.SENTRY_RELEASE || 'development',
    integrations: [
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllText: false
      }),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: '1.0',
    replaysOnErrorSampleRate: '1.0',
    profilesSampleRate: '1.0'
  });
  if (user.name) {
    Sentry.setUser({
      name: user.name,
      email: user.email
    });
  }
}
